import { Accordion } from 'flowbite-react';
import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../Reducers/store';
import CommonApi from '../../Api/CommonApi';
import { Category } from '../../Models/Category';
import { SelectOption } from '../../Models/SelectOption';
import { SubCategory } from '../../Models/SubCategory';
import { CategoryCustom } from '../../Models/CategoryCustom';
import { SubCategoryCustom } from '../../Models/SubCategoryCustom';

export default function CategoriesDisplay() {
  const navigate = useNavigate();
  const [categoryDataL, setCategoryDataL] = useState<CategoryCustom[] | null>();
  const [categoryDataR, setCategoryDataR] = useState<CategoryCustom[] | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getCategories = () => {
    setIsLoading(true);
    CommonApi.getCategoriesCustom()
      .then((res) => {
        if (res.data.length > 0) {
          const chunkLength = Math.max(res.data.length / 2, 1);
          const chunks = [];
          for (let i = 0; i < 2; i++) {
            if (chunkLength * (i + 1) <= res.data.length)
              chunks.push(
                res.data.slice(chunkLength * i, chunkLength * (i + 1))
              );
          }
          if (chunks.length === 2) {
            setCategoryDataL(chunks[0]);
            setCategoryDataR(chunks[1]);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleCategoryClick = (
    category: CategoryCustom,
    subCategory: SubCategoryCustom | null
  ) => {
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '1');
    const categoryValues = {
      label: category.name,
      value: category.id,
    };
    localStorage.setItem(
      'categoriesState',
      JSON.stringify([categoryValues as SelectOption])
    );
    if (subCategory) {
      const subCategoryValues = {
        label: subCategory.name,
        value: subCategory.id,
      };
      localStorage.setItem(
        'subCategoriesState',
        JSON.stringify([subCategoryValues as SelectOption])
      );
    }
    navigate('/products/search');
  };

  return (
    <div className='w-full mt-4'>
      <div className='container mx-auto p-2'>
        <div className='mb-2 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl'>Wholegoods</h1>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='flex-col md:grid md:grid-cols-[40%_40%] gap-5 justify-center h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
            {categoryDataL && (
              <div className='w-full'>
                {categoryDataL.map((category) => (
                  <Accordion
                    key={category.id}
                    collapseAll
                    className='w-4/5 md:w-full m-auto'
                  >
                    <Accordion.Panel>
                      <Accordion.Title className='text-xl text-white bg-gray-500 hover:text-black'>
                        {category.name!}
                      </Accordion.Title>
                      <Accordion.Content>
                        <div
                          key={category.id}
                          className='text-md font-bold text-gray-900 text-center p-1 cursor-pointer hover:bg-gray-100'
                          onClick={() => handleCategoryClick(category, null)}
                        >
                          View All [
                          {category.subCategories?.reduce(
                            (acc, sub) => acc + (sub.count ?? 0),
                            0
                          )}
                          ]
                        </div>
                        {category.subCategories?.map((sub) => (
                          <div
                            key={sub.id}
                            className='text-md font-bold text-gray-900 text-center p-1 cursor-pointer hover:bg-gray-100'
                            onClick={() => handleCategoryClick(category, sub)}
                          >
                            {sub.name!} [{sub.count}]
                          </div>
                        ))}
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                ))}
              </div>
            )}
            {categoryDataR && (
              <div className='w-full'>
                {categoryDataR.map((category) => (
                  <Accordion
                    key={category.id}
                    collapseAll
                    className='w-4/5 md:w-full m-auto'
                  >
                    <Accordion.Panel>
                      <Accordion.Title className='text-xl text-white bg-gray-500 hover:text-black'>
                        {category.name!}
                      </Accordion.Title>
                      <Accordion.Content>
                        <div
                          key={category.id}
                          className='text-md font-bold text-gray-900 text-center p-1 cursor-pointer hover:bg-gray-100'
                          onClick={() => handleCategoryClick(category, null)}
                        >
                          View All [
                          {category.subCategories?.reduce(
                            (acc, sub) => acc + (sub.count ?? 0),
                            0
                          )}
                          ]
                        </div>
                        {category.subCategories?.map((sub) => (
                          <div
                            key={sub.id}
                            className='text-md font-bold text-gray-900 text-center p-1 cursor-pointer hover:bg-gray-100'
                            onClick={() => handleCategoryClick(category, sub)}
                          >
                            {sub.name!} [{sub.count}]
                          </div>
                        ))}
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
